import { motion } from 'framer-motion'
import styled from 'styled-components'

export const StyledBackdrop = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-self: center;
  height: 100vh;
  width: 100vw;
  max-width: 1024px;
  min-width: 320px;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.8);
  z-index: 300;
  overflow: hidden;
`
